import PhotoSwipeLightbox from 'photoswipe/lightbox';

export const galleryTour =  () => {
    const lightbox = new PhotoSwipeLightbox({
        gallery: '#tour-gallery',
        children: 'a',
        // Importación dinámica: el núcleo pesado solo se carga al hacer clic
        pswpModule: () => import('photoswipe')
    });

    lightbox.init();
}
